<template>
    <VJoyPanel v-bind="{}" :data-testid="dataTestid">
        <template v-if="hasSlotTitleAction" #panel-title></template>
        <template v-if="hasSlotTitleAction" #panel-title-action>
            <slot name="edit-form-title-action"></slot>
        </template>
        <template #panel-body>
            <form :id="formId">
                <EditExperienceForm
                    v-model="experienceToEdit"
                    :append-to-element="appendToElement"
                    :new-experience="newExperience"
                    :fields="{
                        skills: {hidden: !skillsEditable},
                    }"
                />
            </form>
        </template>
        <template #panel-action>
            <VJoyWrapper justify="flex-end">
                <VJoyButton variant="ghost" size="small" :data-testid="`${dataTestid}--cta-cancel`" @click="handleClickOnCancel">
                    {{ t('general.cancel') }}
                </VJoyButton>
                <VJoyButton variant="main" size="small" :data-testid="`${dataTestid}--cta-save`" @click="handleClickOnSave">
                    {{ t('general.save') }}
                </VJoyButton>
            </VJoyWrapper>
        </template>
    </VJoyPanel>
</template>
<script setup lang="ts">
    import {computed, ref, useSlots} from 'vue';
    import {useTranslation} from '#imports';
    import {useCollectScope} from '@malt/forms';
    import {validateForm} from '@malt/forms';
    import {VJoyButton, VJoyPanel, VJoyWrapper} from '@maltjoy/core-vue';
    import type {EditExperience} from '~/features/experience/types/EditExperience';
    import EditExperienceForm from '../edition/EditExperienceForm.vue';

    const props = withDefaults(
        defineProps<{
            experience: EditExperience;
            appendToElement?: string;
            newExperience?: boolean;
            skillsEditable?: boolean;
        }>(),
        {
            appendToElement: '.profile-id-or-alias',
            newExperience: false,
            skillsEditable: false,
        },
    );

    const emit = defineEmits<{
        'edit-experience:cancel': [];
        'edit-experience:save': [value: EditExperience];
    }>();

    const formId = 'experience-panel-form';

    const dataTestid = computed(() => `profile-edition-experience-form-item--${props.newExperience ? 'add' : props.experience.id}`);

    const {r$} = useCollectScope('experience-form');
    const {t} = useTranslation();

    const slots = useSlots();
    const hasSlotTitleAction = Object.prototype.hasOwnProperty.call(slots, 'edit-form-title-action');

    const experienceToEdit = ref({
        title: undefined,
        description: undefined,
        company: undefined,
        startDate: undefined,
        endDate: undefined,
        currentJob: undefined,
        ...props.experience,
    });
    function handleClickOnCancel() {
        emit('edit-experience:cancel');
    }

    async function handleClickOnSave() {
        const {valid} = await validateForm(r$, {formId});
        if (!valid) {
            return;
        }
        emit('edit-experience:save', experienceToEdit.value);
    }
</script>
